import { del, get, post, put } from '../../client';
import { shouldLogApiCalls } from '../../config';

export const listScheduledTasks = async (page_at, page_size, sort_by, sort_order, search_term) => {
    if (shouldLogApiCalls) {
        console.log('List scheduled tasks attempt:', { page_at, page_size, sort_by, sort_order, search_term });
    }
    
    const sortParam = sort_by && sort_order ? `&sort_by=${encodeURIComponent(sort_by)}&sort_order=${encodeURIComponent(sort_order)}` : '';
    return get(`/scheduled-task?page_at=${page_at}&page_size=${page_size}${sortParam}`);
}

export const createScheduledTask = async (name, delay_between_runs, automatisation_id, timezone, hour_to_run) => {
    return post(`/scheduled-task`, { name, delay_between_runs, automatisation_id, timezone, hour_to_run });
}

export const updateScheduledTask = async (id, name, delay_between_runs, automatisation_id, timezone, hour_to_run) => {
    return put(`/scheduled-task/${id}`, { name, delay_between_runs, automatisation_id, timezone, hour_to_run });
}

export const deleteScheduledTask = async (id) => {
    return del(`/scheduled-task/${id}`);
}